var render = function render() {
  var _this = this;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "main user-layout-register"
  }, [_c('a-form', {
    ref: "formRegister",
    attrs: {
      "autoFormCreate": function autoFormCreate(form) {
        _this.form = form;
      },
      "id": "formRegister"
    }
  }, [_c('a-form-item', {
    attrs: {
      "label": "学生身份证号/护照号/港澳居住证",
      "fieldDecoratorId": "username",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '账号不能为空'
        }, {
          validator: this.checkUsername
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "type": "text",
      "autocomplete": "false",
      "placeholder": "使用18位身份证号/护照/港澳居住证"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "用户姓名",
      "fieldDecoratorId": "realname",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '姓名不能为空'
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "type": "text",
      "autocomplete": "false",
      "placeholder": "应与身份证上的姓名保持一致"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "手机号码",
      "fieldDecoratorId": "phone",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          pattern: /^1[3456789]\d{9}$/,
          message: '请输入正确的手机号'
        }, {
          validator: this.handlePhoneCheck
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "可用于找回密码，请准确填写"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "邮箱",
      "fieldDecoratorId": "email",
      "fieldDecoratorOptions": {
        rules: [{
          required: false,
          pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/,
          message: '请输入正确的邮箱'
        }, {
          validator: this.handleEmailCheck
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "placeholder": "可用于找回密码，请准确填写"
    }
  })], 1), _c('a-popover', {
    attrs: {
      "placement": "rightTop",
      "trigger": "click",
      "visible": _vm.state.passwordLevelChecked
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm._isMobile(),
      expression: "!_isMobile()"
    }],
    style: {
      width: '240px'
    }
  }, [_c('div', {
    class: ['user-register', _vm.passwordLevelClass]
  }, [_vm._v("强度："), _c('span', [_vm._v(_vm._s(_vm.passwordLevelName))])]), _c('a-progress', {
    attrs: {
      "percent": _vm.state.percent,
      "showInfo": false,
      "strokeColor": _vm.passwordLevelColor
    }
  }), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', [_vm._v("密码为6位数字、字母组合，建议区分大小写。")])])], 1)]), _c('a-form-item', {
    attrs: {
      "label": "密码",
      "fieldDecoratorId": "password",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '至少6位密码，区分大小写'
        }, {
          validator: this.handlePasswordLevel
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "type": "password",
      "autocomplete": "false",
      "placeholder": "请输入密码长度8~16位"
    },
    on: {
      "click": _vm.handlePasswordInputClick
    }
  })], 1)], 2), _c('a-form-item', {
    attrs: {
      "label": "确认密码",
      "fieldDecoratorId": "password2",
      "fieldDecoratorOptions": {
        rules: [{
          required: true,
          message: '至少6位密码，区分大小写'
        }, {
          validator: this.handlePasswordCheck
        }],
        validateTrigger: ['change', 'blur'],
        validateFirst: true
      }
    }
  }, [_c('a-input', {
    attrs: {
      "type": "password",
      "autocomplete": "false",
      "placeholder": "确认密码"
    }
  })], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "register-button",
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary",
      "htmlType": "submit",
      "loading": _vm.registerBtn,
      "readOnly": _vm.registerBtn
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_vm._v("注册\n      ")]), _c('a', {
    staticClass: "forge-password",
    staticStyle: {
      "float": "right",
      "margin-right": "10px",
      "line-height": "30px"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("\n        立即登录\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };